export const DEFAULT_TIMEOUT = 250;
export const IMMEDIATE = 0;

export default function (callback, timeout=DEFAULT_TIMEOUT) {
    setTimeout(callback, timeout);
}